<template>
    <div v-if="document">
        <progress-bar :hasLastStep="hasNextStep"></progress-bar>
        <h1 class="title title--line"><T :title="document.title"> @title uploaden</T></h1>
        <p>{{document.remarks}}</p>
        <form class="form" enctype="multipart/form-data" novalidate>
            <div class="form__errors" v-if="errors.length">
                <div class="form__error" v-for="(error) in errors" v-html="error">
                </div>
            </div>
            <div class="field__container" v-for="uploadedDocument in uploadedDocuments">
                <document-upload-field
                    :uploadUrl="document.uploadUrl"
                    :acceptedTypes="uploadedDocument.possibleNextType"
                    :name="uploadedDocument.name"
                    v-model="uploadedDocument.file"
                >

                </document-upload-field>
            </div>
            <div class="tips">
                <h2><T>Tips bij het uploaden van bestanden</T></h2>
                <ul class="tips__list list">
                    <li class="tips__item"> <T>Zorg voor voldoende omgevingslicht</T></li>
                    <li class="tips__item"> <T>Hou de camera parallel ten opzichte van het document</T></li>
                    <li class="tips__item"> <T>Fotografeer het volledige document</T></li>
                    <li class="tips__item"> <T>Upload steeds de voor- en achterkant van het document</T></li>
                </ul>
            </div>
            <div class="d-flex">
                <back-button v-if="!['documents'].includes($route.name)"></back-button>
                <button class="ml-auto button" v-on:click="save"><T>Volgende Stap</T> <i class="icon-chevron-right button__icon"></i></button>
            </div>
        </form>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'DocumentUpload',
        data: function(){
            return {
                document: null,
                errors: [],
                uploadedDocuments: [],
                nextRouteName: null,
                hasNextStep: null,
            };
        },
        computed: mapState(['activeLocale']),
        watch: {
            // when the activeLocale change then try to translate again
            activeLocale() {
                this.getDocument(false);
                this.removeField();
            },
        },
        mounted() {
            // check if there is a new file uploaded
            this.$root.$on('fileUploaded', (possibleNextType,allowNewField) => {
                // reset the errors array
                this.errors = [];

                var files = this.getFiles();

                // if we may add multiple pages and a document is uploaded add another
                // and all new fields have a value

                if(
                    allowNewField &&
                    this.document.multiplePagesFlag &&
                    ( this.uploadedDocuments.length == files.length) &&
                    this.document.maxPages == null || (this.document.maxPages != null && this.uploadedDocuments.length < this.document.maxPages)) {
                    this.addField(possibleNextType);
                }
            });
            // check if there is a new file uploaded
            this.$root.$on('fileDeleted', () => {
                var files = this.getFiles();

                // if we may add multiple pages and a document is uploaded add another
                // and all new fields have a value
                if(this.uploadedDocuments.length != files.length) {
                    this.removeField();
                }
            });
        },
        methods: {
            addField(possibleNextType) {
                this.uploadedDocuments.push({
                    name: 'file-' + this.uploadedDocuments.length,
                    response: null,
                    possibleNextType: possibleNextType,
                })
            },
            removeField() {
                let emptyFieldKey;

                _.each(this.uploadedDocuments,function(elem,key) {
                    if(elem.file == null) {
                        emptyFieldKey =  key;
                    }
                });

                this.uploadedDocuments.splice(emptyFieldKey,1);
            },
            determineNextStep (form) {
                if(form) {
                    this.nextRouteName = 'document-process';
                } else {
                    this.nextRouteName = 'documents';
                }
            },
            getDocument (deleteIfExists) {
                let self = this;
                self.$store.commit('setLoading',true);

                // get the current document
                this.$Api.get('document/' + this.$route.params.document)
                    .then(function(response) {
                        self.document = response.data;
                        // create a field for the document to be uploaded
                        self.addField(self.document.mimeTypes);
                        self.hasNextStep = response.data.form;
                        self.determineNextStep(response.data.form);
                        // When we already have a document result,
                        // we should ask the user a confirmation to re-upload
                        if (self.document.hasDocumentResult) {
                            self.nextRouteName = "document-confirm-edit";
                            self.redirectToNextRoute();
                        }
                    })
            },
            getFiles() {
                return this.uploadedDocuments.filter(function(elem){
                    if(elem.file !== null) return elem.file;
                });
            },
            redirectToNextRoute() {
                this.$router.push({name: this.nextRouteName, params:{ document: this.document.slug} });
            },
            save(e) {
                e.preventDefault();

                let self = this;
                self.errors = [];
                self.$store.commit('setLoading',true);
                self.$store.commit('setLoadingMessage', t('Even geduld... uw document wordt verwerkt'));

                // gather all the uploaded files
                var files = this.getFiles();

                // check if at least 1 file is uploaded
                if(! files.length) {
                    self.errors.push(t('Gelieven eerst een bestand te uploaden.'))
                }

                if(!this.errors.length) {
                    self.$Api.get('document-save/' + this.$route.params.document)
                        .then(function(response) {

                            if(! response.data.documentsRemaining) {
                                self.nextRouteName = "thank-you";
                            }

                            self.redirectToNextRoute();
                        });
                }
            }
        },
        created: function() {
            this.getDocument();
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/DocumentUpload.vue